<template>
  <!-- ━━━━━ テーブルサイズ調整 ━━━━━ -->
  <colgroup>
    <!-- 種別 -->
    <col style="width: 5em" />
    <!-- ./種別 -->

    <!-- 担当者 -->
    <col style="width: 4em" />
    <!-- ./担当者 -->

    <!-- 時間 -->
    <col style="width: 4em" />
    <!-- ./時間 -->

    <!-- 車種 -->
    <col style="width: 4em" />
    <!-- ./車種 -->

    <!-- 協力店 -->
    <col style="width: 4em" />
    <!-- ./協力店 -->

    <!-- 配送先 -->
    <col style="width: 4em" />
    <!-- ./配送先 -->

    <!-- 備考 -->
    <col />
    <!-- ./備考 -->

    <!-- 処理 -->
    <col style="width: 5em" />
    <!-- ./処理 -->
  </colgroup>

  <!-- ━━━━━ /テーブルサイズ調整 ━━━━━ -->
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent } from "vue";
/* Import Compoments. */
/* Import Scripts. */
/* Import Variables */
export default defineComponent({
  setup() {
    return {
      /* valiables */
      /* script */
    };
  },
});
</script>
